import {
  Main3ContentLeft,
  Main3ContentRight,
  Main3SectionContent,
  Main3SectionWrap,
  Main3LeftBtn
} from 'src/styles/views/Main/main3'
import { main3ScrollItem } from 'src/service/constant/main'
import { useState } from 'react'
import useWindowDimensions from 'src/hooks/useGetWindowSize'

const Main3Section = () => {
  const { width } = useWindowDimensions()
  const [tab, setTab] = useState(0)
  window.addEventListener('scroll', function () {
    if (window.scrollY > 4254 && window.scrollY < 4954) {
      setTab(0)
    } else if (window.scrollY > 4954 && window.scrollY < 5668) {
      setTab(1)
    } else if (window.scrollY > 5668 && window.scrollY < 6352) {
      setTab(2)
    }else if (window.scrollY > 6352 && window.scrollY < 7000) {
      setTab(3)
    }
  })
  return (
    <Main3SectionWrap>
      <Main3SectionContent>
        {width < 1200 && <h4>패밀리케어의 보호기술</h4>}
        <Main3ContentLeft>
          <p>소통을 돕는 <br /> 다양한 기능 제공</p>
          <div className='button_toggle'>
            <Main3LeftBtn
              color={`${tab === 0 && 'active'}`}
              onClick={() => window.scroll({ top: 4300, behavior: 'smooth' })}
            >충격알림
            </Main3LeftBtn>
            <Main3LeftBtn
              color={`${tab === 1 && 'active'}`}
              onClick={() => window.scroll({ top: 5000, behavior: 'smooth' })}
            >미사용감지
            </Main3LeftBtn>
            <Main3LeftBtn
              color={`${tab === 2 && 'active'}`}
              onClick={() => window.scroll({ top: 5669, behavior: 'smooth' })}
            >패밀리공간
            </Main3LeftBtn>
            <Main3LeftBtn
                color={`${tab === 3 && 'active'}`}
                onClick={() => window.scroll({ top: 6400, behavior: 'smooth' })}
            >긴급호출
            </Main3LeftBtn>
          </div>
        </Main3ContentLeft>
        <Main3ContentRight>
          {main3ScrollItem.map((option: any, index: number) => (
            <section key={option.title}>
              <img src={width > 1200 ? option.imgSrc : option.moImgSrc} alt='content img' />
              <div>
                <p>{option.title}</p>
                <pre dangerouslySetInnerHTML={{__html: option.desc}} />
              </div>
            </section>
          ))}
        </Main3ContentRight>
      </Main3SectionContent>
    </Main3SectionWrap>
  )
}
export default Main3Section
